import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { jobOffer } from 'job/model/job-offer.fragments';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { JobOfferOutput } from '../model/job-offer.output';

export interface CreateJobOfferParams {
	readonly title: string;
	readonly ownerId: string;
	readonly keyPoints: string;
	readonly companyName: string;
	readonly contractType: string;
	readonly moduleColumnId: string;
	readonly organizationModuleId: string;
}

@Injectable({ providedIn: 'root' })
export class CreateJobOfferApiMutation extends ApiMutation<
	JobOfferOutput,
	CreateJobOfferParams
> {
	client = 'iam';
	document = gql`
		mutation CreateJobOffer(
			$companyName: String
			$contractType: String
			$keyPoints: String
			$moduleColumnId: UUID!
			$organizationModuleId: UUID!
			$ownerId: UUID!
			$title: String!
		) {
			createJobOffer(
				ownerId: $ownerId
				companyName: $companyName
				contractType: $contractType
				keyPoints: $keyPoints
				moduleColumnId: $moduleColumnId
				organizationModuleId: $organizationModuleId
				title: $title
			) {
				...JobOffer
			}
		}
		${jobOffer}
	`;
	method = 'createJobOffer';
}
